import { ApiService } from '@libs/core/base-config';
import { Dtos, exchangeRateResponseSchema, paymentIntentResponseSchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function paymentIntentConfirm(
  apiService: ApiService,
  { paymentIntentId, topUpPaymentMethod, metadata }: Dtos.PaymentIntentConfirmBody,
) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/payment-intents/payment-intent-confirm`, {
    paymentIntentId,
    topUpPaymentMethod,
    metadata,
  });
}

export function createPaymentIntent(
  apiService: ApiService,
  { type, amount, topUpPaymentMethod, orderId, identityCard, masaratSessionToken }: Dtos.CreatePaymentIntentBody,
) {
  return apiService.http
    .post(`${apiService.baseUrl}/api/v1/payment-intents/create-payment-intent`, {
      type,
      amount,
      topUpPaymentMethod,
      orderId,
      identityCard,
      masaratSessionToken,
    })
    .pipe(map((data) => paymentIntentResponseSchema().parse(data)));
}

export function exchangeRate(apiService: ApiService) {
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/payment-intents/exchange-rate`, {})
    .pipe(map((data) => exchangeRateResponseSchema().parse(data)));
}
